module.exports = __webpack_public_path__ + "img/Carousel-Financial-Wellness.eef92155.jpeg";